import React, { useState, useEffect } from "react";
import { Card, Badge, Spinner } from "react-bootstrap";
import { fetchCommandeFeedback } from "../CommandesFournisseurs/DataService";
import moment from "moment";

const TYPE_LABEL = { pickup: "Ramassage", delivery: "Livraison" };

function CommandeFeedback({ commandeId }) {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await fetchCommandeFeedback(commandeId);
        setFeedback(data);
      } catch (error) {
        console.error("Error loading commande feedback:", error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [commandeId]);

  if (loading) {
    return (
      <Card className="mb-3">
        <Card.Body className="text-center">
          <Spinner animation="border" size="sm" />
        </Card.Body>
      </Card>
    );
  }

  if (feedback.length === 0) {
    return null;
  }

  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title className="pb-3">Feedback ramassage / livraison :</Card.Title>
        {feedback.map((item) => (
          <div key={item.id} className="mb-2 d-flex align-items-start gap-2">
            <Badge bg={item.went_well ? "success" : "warning"} text={item.went_well ? undefined : "dark"}>
              {TYPE_LABEL[item.type] || item.type}
            </Badge>
            <div>
              {item.went_well ? (
                <span>Tout s'est bien passé</span>
              ) : (
                <span>
                  {item.category && <strong>{item.category}</strong>}
                  {item.category && (item.label || item.reason_text) && " — "}
                  {item.label || item.reason_text || "Problème signalé (sans détail)"}
                </span>
              )}
              <div className="text-muted" style={{ fontSize: 12 }}>
                {moment(item.created_at).format("DD-MM-YYYY HH:mm")}
              </div>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}

export default CommandeFeedback;
